<template>
  <div class="">
    <div class="sks clearfix">
    
        <div class="zi">
 {{certification==1? vip==1?'会员中心':'已认证' : "尚未认证"}}
        </div>
     
<div class="rit" @click="goset">
      <!-- <van-icon class="ri" name="chat-o" /> -->

<van-icon class="ri" name="setting-o" />
</div>
      
    </div>
    <div class="ceonten">
      <div class="ti">
        <div class="information clearfix">
        <img
        v-if="vip"
          @click="goset"
          src="../../assets/my/vip1.png"
          alt=""
        >
        <img
        v-else
          @click="goset"
          src="../../assets/my/vip2.png"
          alt=""
        >
        <div
          class="name"
          @click="goset"
         
        >
          <p class="names">{{name}}</p>
          <div  class="">
             <p class="vip">{{vip?'鲸会员':"注册用户"}} </p>
          <p
            v-show="vip"
            style="color:#716451; padding: 0.2rem;float: left;"
          >{{time}}到期</p>
          </div>
          
        </div>
         <div   :class="vip?'vipc1':'vipc2'" class="open clesrfix">
          
          <div
            class="content"
            @click="op"
          >
             <p>{{vip?"立即续费":"立即成为鲸会员"}}</p> 
          </div>
        </div>
      </div>
      <div class="cans clearfix">
        <div class="can1">
          <p>钱包余额</p>
          <!-- <p v-else>{{vip? 0:'--'}}</p> -->
          <p >{{ 0}}</p>

        </div>
        <div class="can1">
          <p>鲸点余额</p>

          <p >{{fanm}}</p>
          <!-- <p v-else>{{vip? fanm:'--'}}</p> -->
        </div>
        <!-- <div class="can1">
          <p>积分余额</p>
          <p>{{vip?'0':'--'}}</p>
        </div> -->
        <div class="can1">
          <p>优惠劵</p>
          <!-- <p >{{vip?a+'张':'--'}}</p> -->
          <p >{{a+'张'}}</p>
        </div><div class="can1">
          <p>鲸信用</p>
          
          <!-- <p >{{vip?0:'--'}}</p> -->
          <p >{{this.yu2}}</p>
        </div>
      </div>
      <div v-if="vip" class="jie">
        <p>累计已节省(元)</p>
        <p>{{fansm.toFixed(2)}}</p>
      </div>
      <div class="jie1" v-else>
        关注APP发现更多权益！
      </div>
      <div class="order">
        <div class="title">我的订单
          <van-icon
            class="fr ic"
            name="arrow"
          />
          <div class="fr" @click="onClick(1)">全部订单</div>

        </div>
        <ul class="fanr clearfix">
          <li @click="onClick(2)">
            <img
              src="../../assets/my/d1.png"
              alt=""
            >
            <p>已提交</p>
          </li>
          
         
          <li @click="onClick(3)">
            <img
              src="../../assets/my/d4.png"
              alt=""
            >
            <p>已完成</p>
          </li>
           <li @click="onClick(4)">
            <img
              src="../../assets/my/d5.png"
              alt=""
            >
            <p>已取消</p>
          </li>
          <li @click="onClick(41)">
            <img
              src="../../assets/my/d5.png"
              alt=""
            >
            <p>退货单</p>
          </li>
          <!-- <li @click="onClick(411)">
            <img
              src="../../assets/my/d5.png"
              alt=""
            >
            <p>促销预售</p>
          </li> -->
        </ul>
      </div>
      <div class="order o1">
        <div class="title">功能服务
          <van-icon
            class="fr ic"
            name="arrow"
          />
        </div>
        <ul class="clearfix">

          <!-- <li @click="onClick(0)">
            <div class="imgs">
              <img
                src="../../assets/my/g1.png"
                alt=""
              >
            </div>
            <p>我的收藏</p>
          </li>
          <li @click="onClick(0)">
            <div class="imgs">
              <img
                src="../../assets/my/g2.png"
                alt=""
              >
            </div>
            <p>我的积分</p>
          </li> -->
          <li  @click="onClick(13)">
            <img
              src="../../assets/my/g3.png"
              alt=""
            >
            <p>鲸点返利</p>
          </li>
          <li @click="onClick(6)">
            <img
              src="../../assets/my/g4.png"
              alt=""
            >
            <p>优惠券</p>
          </li>
          <li  @click="onClick(20)">
            <img
              src="../../assets/my/g5.png"
              alt=""
            >
            <p>鲸信用</p>
          </li>
          <li  v-show="xys>0" @click="onClick(21)">
            <img
              src="../../assets/my/g2.png"
              alt=""
            >
            <p>销售提成</p>
          </li>
          <li @click="onClick(5)">
            <img
              src="../../assets/my/g6.png"
              alt=""
            >
            <p>收货地址</p>
          </li>
          <!-- <li @click="onClick(0)">
            <img
              src="../../assets/my/g7.png"
              alt=""
            >
            <p>交易账单</p>
          </li> -->
          <!-- <li @click="onClick(80)">
            <img
              src="../../assets/my/g8.png"
              alt=""
            >
            <p>申请退货</p>
          </li>
           <li @click="onClick(80)">
            <img
              src="../../assets/my/g8.png"
              alt=""
            >
            <p>退货单</p>
          </li> -->
          <!-- <li @click="onClick(7)">
            <img
              src="../../assets/my/g9.png"
              alt=""
            >
            <p>申请开票</p>
          </li> -->
          <!-- <li @click="onClick(0)">
            <img
              src="../../assets/my/g10.png"
              alt=""
            >
            <p>投诉建议</p>
          </li> -->
          <li @click="onClick(9)">
            <img
              src="../../assets/my/g11.png"
              alt=""
            >
            <p>客服中心</p>
          </li>
          <li @click="onClick(10)">
            <img
              src="../../assets/my/g12.png"
              alt=""
            >
            <p>用户协议</p>
          </li>
          <li @click="onClick(11)">
            <img
              src="../../assets/my/g13.png"
              alt=""
            >
            <p>隐私政策</p>
          </li>
          <li @click="onClick(111)" v-show="uid==7360 || uid==8168|| uid==96">
            <img
              src="../../assets/my/g12.png"
              alt=""
            >
            <p>信用审核</p>
          </li>
        </ul>
      </div>
      <div   class="dg" @click="op">
      <img src="../../assets/my/dg.png" alt=""> 

      </div>
      </div>
      
    </div>
    
    <div class="bottom">
      
      
    </div>
    <van-dialog v-model="sshow" @confirm='goss' title="提示" show-cancel-button confirmButtonText="已阅读并同意">
  <p style="text-align: center;padding: 0.6rem 0;">请您先阅读并同意 <span style="color: red;" @click="onk">《货空间鲸信用服务协议》</span></p>
</van-dialog>
  </div>
</template>
<script>
import Vue from 'vue'
// import List from './child/list'
import {  Dialog, Toast} from 'vant'

Vue.use(Dialog)
export default {
  created () {
    this.name = JSON.parse(localStorage.getItem('user-name')).id
   this.uid=JSON.parse(localStorage.getItem('user')).id
    this.deng()
    this.$store.state.tgood=[]
    this.axios.get('getFanliMoney',{ params: { store_id: this.$store.state.shopid } }).then(res => {
      // console.log(res)
        if(res.data.code==200){
          this.fanm=res.data.data.money
         
        }
          // console.log(res.data.data.rate)
      }).catch(ref => {
      })
       this.axios.post('getPreAccount', { store_id: this.$store.state.shopid }).then(res => {
        // console.log(res)
        // console.log(this.list)
         this.yu=+res.data.data.pre_account_money
       
      }).catch(ref => { })
   
 this.axios.post('accountQuota', {}).then(res => {
       this.yu2=+res.data.data.shengyuedu
       this.m2=res.data.data.is_delete
      
      }).catch(ref => { })
      this.axios.post('coupon_num', { page: this.page, store_id: this.$store.state.shopid }).then(res => {
        if (res.data.code == 1004) {
          localStorage.setItem('token', JSON.stringify({ id: res.data.token }))
          this.deng()
        }
        this.a = res.data.count.notUseCoupon
      
        // this.nouse = res.data.data
      }).catch(ref => { })
      this.axios.post('yanzheng', { }).then(res => {
        console.log(res)
        this.certification=res.data.data.certification
      }).catch(ref => { })
     
    // this.$router.go()
  },
  data () {
    return {
      vip: false,
      name: '',
      time: "",
      certification:0,
      fanm:0,
      yu:0,
      yu2:0,
      fansm:0,
      shopid:0,
      a:0,
      uid: 0,
      sshow: false,
      m2: 0,
      xys:0

    }
  },
  methods: {
    gos () {
      this.$router.push("/")
    },
    onClick (i) {
      if ([0,1, 2, 3,4].find(v => v == i)) {
        this.$router.push({ name: 'orderList', query: { i: i } })
      }
      if (i == 41) {
        this.$router.push({ name: 'tui2',query: { id :1 }})
      }
      if(i==411){
        this.$router.push('chuxol')

      }
      if (i == 5) {
        this.$router.push({ name: 'address'})
      }
      if (i == 6) {
        this.$router.push('coupon')
      }
      
      if (i == 13) {
        this.$router.push('fan')
      }
      if (i == 21) {
        this.$router.push({name:'fanxy',query:{id:this.xys}})
      }
      if (i == 7) {
        this.$router.push('tax')
      }
      if (i == 8) {
        this.$router.push({ name: 'set', params: { name: 11, mobile: 11 } })
      }

      if (i == 9) {
        this.$router.push('customer')
      }
      if (i == 10) {
        this.$router.push('agreement')
      }
       if (i == 11) {
        this.$router.push('agreement1')
      }
       if (i == 80) {
        this.$router.push('tui')
      }
      if(i==12){
        this.$router.push('logoff')

      }
      if(i==111){
        this.$router.push('shen')

      }
      if (i == 20) {
        
        if (this.vip == 1) {
          if (this.m2 == 2) {
            this.sshow=true
            return
          }
        
        this.$router.push('shang')

        }else{
Dialog.confirm({
        title:'',
        message: '您的账号当前为非鲸会员状态，无法使用此服务，请先开通会员',
confirmButtonText:'开通鲸会员'
      }).then(() => {
      this.op()
       
      }).catch(() => {
      })
        }

      }
    },
    goss () {
      this.axios.post('upjxyaccdelstatus', { checkstatus: '1', }).then(res => {
        this.sshow=false
        this.$router.push('shang')

      }).catch(ref => { 
        this.sshow=false
          
         })
     
    },
    deng () {
      this.axios.post('userInfo', { store_id: this.$store.state.shopid, }).then(res => {
        if (res.data.code == 1004) {
          localStorage.setItem('token', JSON.stringify({ id: res.data.token }))
          this.deng()
        }
        if (res.data.code == 200) {
          // console.log(res)
          localStorage.setItem('vip', JSON.stringify({ id: res.data.info.super_vip }))
          localStorage.setItem('user-level', JSON.stringify({ id: res.data.info.level }))
          // this.certification=res.data.info.certification
           this.vip = res.data.info.super_vip  == 1 ? true : false
          this.shopid = res.data.info.store_id
          this.xys=res.data.info.sale_per
          let data = new Date(res.data.info.vipInfo.end_time * 1000)
          let year = data.getFullYear()
          // console.log(1)
          let month = data.getMonth() + 1
          let day = data.getDate()
          month = month < 10 ? '0' + month : month
          day = day < 10 ? "0" + day : day
          console.log()
          this.time = year + "-" + month + "-" + day
         this.fansm= res.data.info.save_money
        }
      }).catch(ref => { })
      // this.axios.post('getFanliList',{ start:(new Date('2024-1-1'.replace(/-/g,'/')).getTime()/1000)  ,end:(new Date('2026-1-30'.replace(/-/g,'/')).getTime())/1000, }).then(res => {       
      //     console.log(res)       
       
      //   res.data.data.forEach(v=>{
      //     if(v.flag==1){
      //       // this.fansm+= Number(v.bendan_fanli_money)

      //     }else{
      //       this.fansm+= Number(v.fanli_money)
      //     }
      //   })
      //     res.data.data.forEach(v=>{
      //     if(v.remarks=='订单取消'){
      //       // this.fansm+= Number(v.bendan_fanli_money)
      //       this.fansm-= Number(v.fanli_money)

      //     }
      //   })
          
      //     // console.log(res)
      // }).catch(ref => {
      // })
    },
    goset () {
      this.$router.push('set')
    },
    govip () {
      this.$router.push('vip')
    },
    onk () {
      this.$router.push('agreement3')
    },
    op(){
      if([1,3,51,56,22].indexOf(this.shopid)!=-1){
 if(this.certification==1){
      this.$router.push('opvip2')
      }else{
        Toast('请先认证')
      this.$router.push('ren')
      }
      }else{
        Toast('请联系业务员开通')
      }
     
    }
    // formatDate (date) {
    //   let date = new Date(date);
    //   let YY = date.getFullYear() + '-';
    //   let MM = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + '-';
    //   let DD = (date.getDate() < 10 ? '0' + (date.getDate()) : date.getDate());
    //   let hh = (date.getHours() < 10 ? '0' + date.getHours() : date.getHours()) + ':';
    //   let mm = (date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes()) + ':';
    //   let ss = (date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds());
    //   return YY + MM + DD + " " + hh + mm + ss;
    // }
  }
}
</script>
<style lang="less" scoped>
.sks {
  width: 100%;
  z-index: 99;
  height: 1.2rem;
  background-color: #2e3349;
  text-align: center;
  font-size: 0.45rem;
  line-height: 1.2rem;
  color: #fafffb;
  position: relative;
  .zi{
    font-size: 0.4rem;
  }
  // position: fixed;
  // top: 0;
  // left: 0;
  //   margin-top: 0.5rem;
  // position: fixed;
  // top: 0;
  // z-index: 99;
  // width: 100%;
  span {
    width: 1rem;
    position: absolute;
    left: 0;
    font-size: 0.5rem;
  }
  .rit{
    position: absolute;
    top: 0;
    right: 0.1rem;
  }
  .ri{
    float:right;
    font-size: 0.5rem;
    padding-right: 0.35rem;
    padding-top: 0.4rem;
  }
}
.dg{
  position: absolute;
  bottom: -1.4rem;
  width: 90%;
  right: 5%;
}
.ceonten{
  background-color: #2e3349;
padding: 0 0.2rem;
//  height: 15rem;
padding-bottom: 1.5rem;
.ti{
 height: 20rem;
 position: relative;
  width: 100%;
   background: url(../../assets/my/bei.png) no-repeat center;
   background-size: 100% 125%;
    .information {
      padding-top: 0.5rem;
      padding-left: 0.8rem;
    img {
      float: left;
      width: 1.4rem;
    }
     .name {
    float: left;
    padding: 0.2rem 0 0 0.3rem;
    .names {
      font-weight: 700;
      padding-bottom: 0.1rem;
      font-size: 0.41rem;
      color: #1a263e;
    }
    .vip {
      float: left;
      margin: 0.1rem 0;
      width: 1.6rem;
      height: 0.5rem;
      background-color: #b18a45;
      font-size: 0.3rem;
      text-align: center;
      line-height: 0.5rem;
      border-radius: 0.25rem;
      color: #f5e2b8;
    }
     .vip1 {
      margin: 0.1rem 0;
      width: 1.6rem;
      height: 0.5rem;
      background-color: #929292;
      font-size: 0.3rem;
      text-align: center;
      line-height: 0.5rem;
      border-radius: 0.25rem;
      color: #f5e2b8;
    }
  }
  
  .open {
    position: absolute;
    top: 1rem;
    right: 0.4rem;
    // margin-top: 0.2rem;
    width: 2.2rem;
    float: right;
    padding: 0.2rem;
    padding-left: 0.2rem;
    padding-right: 0.03rem;
    border-top-left-radius: 0.7rem;
    border-bottom-left-radius: 0.7rem;
    background-color: #1b203e;
    .round {
      float: left;
      width: 0.85rem;
      height: 0.85rem;
      border-radius: 100%;
      background-color: #575757;
      position: relative;
      img {
        width: 0.6rem;
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);
      }
    }
    .content {
      float: left;
      padding-left: 0.2rem;
      color: #efe1c1;
      p {
        font-size: 12px;
      }
      p:nth-child(1) {
        padding: 0.1rem;
        font-size: 13px;
      }
      p:nth-child(2) {
        font-size: 10px;
      }
    }
  }
  .vipc1{
    width: 2.2rem;
  }
  .vipc2{
    width: 3.2rem;
  }
  }
  .cans{
    padding-left: 0.4rem;
    padding-top: 0.5rem;
    .can1{
      float: left;
      width: 24%;
      text-align: center;
      border-right:0.026667rem solid #2e3349 ;
      p{
      font-size: 0.35rem;
      padding-top: 0.2rem;
      font-weight: 550;
      }
    }
  }
  .jie{
    text-align: center;
    padding-top: 0.3rem;
    color: #6b5229;
p:nth-child(2) {
        font-size: 0.45rem;
        color: #604a21;
        font-weight: 600;
        padding-top: 0.13rem;
      }
  }
  .jie1{
    text-align: center;
    padding-top: 0.5rem;
    color: #6b5229;
  }
 
}
}
.vipuser {
  background-color: #3e3e3e;
}
.user {
  background: linear-gradient(90deg, #cfbe92, #bea975);
}
.top {
  padding: 1.1rem 0 0 0.5rem;
  height: 4.666667rem;
  .information {
    img {
      float: left;
      width: 1.733333rem;
    }
  }
  .name {
    float: left;
    padding: 0.4rem 0 0 0.3rem;
    .names {
      font-weight: 700;
      padding-bottom: 0.1rem;
      font-size: 0.41rem;
      color: #fff;
    }
    .vip {
      margin: 0.1rem 0;
      width: 1.6rem;
      height: 0.5rem;
      background-color: #efe1f1;
      font-size: 0.3rem;
      text-align: center;
      line-height: 0.5rem;
      border-radius: 0.25rem;
      color: #bbab26;
    }
  }
  
  .integral {
    color: #fff;
    .num {
      font-size: 18px;
      padding-left: 0.3rem;
      // text-align: center;
      padding-top: 0.3rem;
      font-weight: 700;
      padding-bottom: 0.1rem;
    }
    .use {
      padding-left: 0.3rem;
      p {
      }
      span {
        float: left;
        transform: rotate(90deg);
        display: block;
      }
    }
  }
}
.bottom {
  background-color: #f5f5f5;
}
.order {
  margin-top: 1.1rem;
  // background-color: #fff;
  margin-bottom: 0.3rem;
  padding: 0 0.6rem 0 0.6rem;
  .title {
    border-bottom: 1px solid #e6e6e6;
    line-height: 1.3rem;
    font-size: 0.346667rem;
    font-weight: 550;
    color: #333;
    .ic {
      font-size: 0.4rem;
      line-height: 1.3rem;
    }
  }
  li {
    float: left;
    width: 20%;
    padding: 0.4rem 0;
    height: 2rem;
    .imgs {
      height: 0.5rem;
    }
    img {
      width: 0.56rem;
      height: 0.6rem;
      margin: 0 auto;
    }
    p {
      text-align: center;
      padding-top: 0.5rem;
      color: #606060;
    }
  }
  .fanr{
    li{
      width: 25%;
    }
  }
  // li:nth-child(8){
  //   p{
  //     padding-top: 0.35rem;
  //   }
  // }
  // li:nth-child(5){
  //   p{
  //     padding-top: 0.55rem;
  //   }
  // }
}
.o1{
  margin-top: 0.5rem;
}
</style>